import { Skills } from '@/lib/types'
import { useTranslation } from '@/i18n'

interface DetailedTableProps {
  skills: Skills
}

export function DetailedTable({ skills }: DetailedTableProps) {
  const { t } = useTranslation()

  return (
    <section className="py-8 px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 dark:text-gray-100">{t('skills.title')}</h2>

        {skills.groups.map((group) => (
          <div key={group.id} className="mb-8">
            <h3 className="text-xl font-semibold mb-4 dark:text-gray-200">{group.title}</h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-200 dark:border-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-800">
                  <tr>
                    <th className="text-left p-3 font-semibold dark:text-gray-200">
                      {t('skills.skill')}
                    </th>
                    <th className="text-left p-3 font-semibold dark:text-gray-200">
                      {t('skills.level')}
                    </th>
                    <th className="text-left p-3 font-semibold dark:text-gray-200">
                      {t('skills.source')}
                    </th>
                    <th className="text-left p-3 font-semibold dark:text-gray-200">
                      {t('skills.evidence')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {group.items.map((skill, i) => (
                    <tr key={i} className="border-t border-gray-200 dark:border-gray-700">
                      <td className="p-3 font-medium dark:text-gray-200">{skill.name}</td>
                      <td className="p-3">
                        <span className="text-blue-600 font-semibold dark:text-blue-400">
                          {skill.level}
                        </span>
                      </td>
                      <td className="p-3 text-gray-600 dark:text-gray-400">{skill.source}</td>
                      <td className="p-3 text-gray-600 dark:text-gray-400 text-xs">
                        {skill.evidence.join(', ')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}

        {/* Soft Skills Section */}
        {skills.soft_skills && skills.soft_skills.length > 0 && (
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-4 dark:text-gray-200">
              {t('skills.softSkills')}
            </h3>
            <div className="flex flex-wrap gap-2">
              {skills.soft_skills.map((skill, i) => (
                <span
                  key={i}
                  className="px-4 py-2 bg-purple-100 text-purple-800 rounded-full text-sm font-medium dark:bg-purple-900/30 dark:text-purple-300"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
